import { render, staticRenderFns } from "./ExamTypesList.vue?vue&type=template&id=2557effc"
import script from "./ExamTypesList.vue?vue&type=script&lang=js"
export * from "./ExamTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports